(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product__recommendations"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    function updateButtons() {
        document.querySelectorAll(".shopify-payment-button__more-options").forEach(button => {
            if (button.textContent.trim() === "More payment options") { 
                button.textContent = "Buy Now";
            }
        });
    }

    // Run initially
    updateButtons();

    // Observe DOM changes and reapply when elements are updated
    const observer = new MutationObserver(updateButtons);
    observer.observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();
})();
